import styles from "./BottomText.module.less";

const defaultTexts = {
  nomore: "已经到底啦～",
  loading: "正在加载～",
  empty: "哎呀，暂无符合条件的资源哦~",
};

const BottomText = ({
  isLoading = false,
  dataList = [],
  hasMore = true,
  texts = defaultTexts,
  className = "",
}) => {
  const getDisplayText = () => {
    if (isLoading) {
      return texts.loading;
    }

    if (dataList.length === 0) {
      return texts.empty;
    }

    if (!hasMore) {
      return texts.nomore;
    }
    return "";
  };

  const displayText = getDisplayText();
  if (!displayText) return null;

  return (
    <>
      {displayText === texts.empty ? (
        <div className={styles["empty-box"]}>
          <img
            className={styles["empty-img"]}
            src={require("@/images/picture/home/empty-phone.png")}
          />
          <div className={styles["bottom-text-container"]}>{displayText}</div>
        </div>
      ) : (
        <div className={`${styles["bottom-text-container"]} ${className}`}>
          {displayText}
        </div>
      )}
    </>
  );
};

export default BottomText;